export function isDevtoolEnabled() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-underscore-dangle
    if ((window as any).__NEXT_DEVTOOLS_EXTENSION__?.enabled) {
        return true
    }

    return false
}
